/* istanbul ignore next */
const ACTIONS = {
    POPULATE_INFORMATION_PAGE_MESSAGE: 'POPULATE_INFORMATION_PAGE_MESSAGE',
    IS_EMAIL_ICON_HOVERED: 'IS_EMAIL_ICON_HOVERED',
    IS_HELP_ICON_HOVERED: 'IS_HELP_ICON_HOVERED',
    UPDATE_INELIGIBILITY_STATUS_CODE: 'UPDATE_INELIGIBILITY_STATUS_CODE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    populateInformationPageMessage(messageKey, ineligibilityStatus, brandName, siteName) {
        return {
            type: ACTIONS.POPULATE_INFORMATION_PAGE_MESSAGE,
            payload: {
                messageKey,
                ineligibilityStatus,
                brandName,
                siteName
            }
        };
    },

    emailIconMouseHovered(emailIconHoverStatus) {
        return {
            type: ACTIONS.IS_EMAIL_ICON_HOVERED,
            payload: {
                emailIconHoverStatus
            }
        };
    },

    helpIconMouseHovered(helpIconHoverStatus) {
        return {
            type: ACTIONS.IS_HELP_ICON_HOVERED,
            payload: {
                helpIconHoverStatus
            }
        };
    },

    updateIneligibilityStatusCode(statusCode) {
        return {
            type: ACTIONS.UPDATE_INELIGIBILITY_STATUS_CODE,
            payload: {
                statusCode
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
